// eslint-disable-next-line prefer-regex-literals
const isUrlAbsolute = (url: string): boolean => new RegExp('^([a-z]+://|//)', 'i').test(url);

export default isUrlAbsolute;
